import { Request } from "@/forms/ViewModelFormTypes";

export class InitViewModel {
  public loadPageRequest: Request = { loading: false, error: "" };
}
